module.exports = __webpack_public_path__ + "img/waterproofing.650503dd.jpg";